<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="blue">
                        <v-toolbar-title class="my-0 py-0">Generador de Número de Notas</v-toolbar-title>
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="4" md="2">
                                <h6 color="black"><b>NOTA N°: {{ codgral + "/" + periodo }}</b></h6>
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-text-field required :rules="requiredRules" label="Fecha:" dense
                                    v-model="fecha"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="2" md="4">
                                <v-text-field required :rules="requiredRules" label="Responsable:" dense
                                    v-model="resp"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <v-text-field label="Factibilidad:" dense v-model="fact"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Empresa" dense v-model="empresa">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Referencia" dense v-model="referencia">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        codgral: "",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        empresa: "",
        resp: "",
        referencia: "",
        fact: "",
        fecha: moment().format("DD/MM/YYYY"),
        periodo: moment().format("YY"),
        mensaje: "",
    }),

    computed: {
        show: {
            get() {
                //this.mostrar = true;
                this.resp = this.$store.state.nombre.toString().trim();
                this.codigonota();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            this.empresa = "";
            this.codgral = "";
            this.resp = "";
            this.referencia = "";
            this.fact = "";
            this.fecha = moment().format("DD/MM/YYYY");
            this.$router.push({ name: "MainComercial" });
        },
        codigonota() {
            let self = this;
            axios
                .get("/Comercial/CodigoNota?")
                .then((response) => {
                    console.log(response.data);
                    self.codgral = response.data.codgral;
                })
                .catch((error) => {
                    self.codgral = "";
                    console.log(error);
                });
        },

        guardar() {
            this.$swal({
                title: "Guardar Nota",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var datos = {
                        codgral: this.codgral,
                        empresa: this.empresa,
                        referencia: this.referencia,
                        responsable: this.resp,
                        fecha: this.fecha,
                        periodo: this.periodo,
                        fact: this.fact,
                    };
                    let self = this;
                    axios
                        .post("/Comercial/GuardarNota", datos)
                        .then((response) => {
                            var data = response.data || {};
                            var numnota = data.codgral || "";
                            self.$refs.form.resetValidation();

                            if (data.mailEnviado === false) {
                                // La nota se registró pero el mail no se pudo enviar.
                                self.$swal.fire({
                                    icon: "warning",
                                    title: "N° de NOTA asignado: " + numnota + "/" + self.periodo,
                                    text:
                                        data.mensaje ||
                                        "La nota se registró correctamente, pero no se pudo enviar el mail de aviso.",
                                    background: "#ececec",
                                    confirmButtonText: "Entendido",
                                });
                            } else {
                                self.mensaje = "N° de NOTA asignado: " + numnota + "/" + self.periodo;
                                self.showAlert({
                                    icon: "success",
                                    title: self.mensaje,
                                    vm: self,
                                });
                            }

                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                            self.deshabilitar = false;
                            var msg = "No se pudo guardar la nota. Intente nuevamente.";
                            if (error.response && error.response.data && error.response.data.mensaje) {
                                msg = error.response.data.mensaje;
                            }
                            self.$swal.fire({
                                icon: "error",
                                title: "Error al guardar",
                                text: msg,
                                background: "#ececec",
                                confirmButtonText: "Cerrar",
                            });
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 5000,
            });
        },
    },
};
</script>
